import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewChecked,
  Type,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import {
  AcNotification,
  ActionType,
  ViewerConfiguration,
} from "angular-cesium";
import * as _ from "lodash";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { filter, map, mergeAll, pluck, tap } from "rxjs/operators";
import { DeviceDatosMapaModalComponent } from "src/app/components/device-datos-mapa-modal/device-datos-mapa-modal.component";
import { DeviceDatosComponent } from "src/app/components/device-datos/device-datos.component";
import { SeleccionTiposDatosModalComponent } from "src/app/components/seleccion-tipos-datos-modal/seleccion-tipos-datos-modal.component";
import {
  DataTypeItem,
  DatatypeTreeHierarchi,
} from "src/app/models/datatype/datatype-hierarchi.model";
import { DataTypeService } from "src/app/services/datatype/data-type.service";
import { TimezoneService } from "src/app/services/timezone.service";
import { ToastService } from "src/app/services/toast/toast.service";
import {
  GeoDevicesService,
  EntidadGeoPOS,
  EntidadMapa,
  TipoDato,
} from "../../services/mapa/geodevices.service";

@Component({
  selector: "mapa",
  templateUrl: "./mapa.component.html",
  styleUrls: ["./mapa.component.scss"],
  providers: [ViewerConfiguration],
})
export class MapaComponent implements OnInit, OnDestroy {
  @Input() name: string;
  dataTypeTree: DatatypeTreeHierarchi[];
  timezoneBS: BehaviorSubject<string> = new BehaviorSubject<string>("");
  entities$: Observable<AcNotification>;
  selectedDataTypes: DataTypeItem[] = [];
  modalDataTypesSuscription: Subscription;

  constructor(
    private viewerConf: ViewerConfiguration,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private datatypeService: DataTypeService,
    private translate: TranslateService,
    private timezone: TimezoneService,
    private toastr: ToastService,
    private geoDevicesService: GeoDevicesService
  ) {
    viewerConf.viewerOptions = {
      selectionIndicator: true,
      timeline: false,
      infoBox: true,
      fullscreenButton: true,
      baseLayerPicker: false,
      animation: false,
      shouldAnimate: false,
      homeButton: true,
      geocoder: false,
      navigationHelpButton: false,
      navigationInstructionsInitiallyVisible: false,
      mapMode2D: Cesium.MapMode2D.ROTATE,
      sceneMode: Cesium.SceneMode.SCENE2D,
    };

    // Will be called on viewer initialistion
    viewerConf.viewerModifier = (viewer: any) => {
      // Remove default double click zoom behaviour
      //viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    };
  }
  ngOnDestroy(): void {
    if (this.modalDataTypesSuscription) {
      this.modalDataTypesSuscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.detectChanges();
  }

  detectChanges() {
    this.timezone.currentTimeZone$.subscribe((data: string) => {
      this.timezoneBS.next(data);
    });
  }

  openTipoDatosModal() {
    // console.log ('opening modal');
    this.openDialog();
  }

  openDialog() {
    //const dialogRef = this.dialog.open(DeviceDatosMapaModalComponent, {
    const dialogRef = this.dialog.open(SeleccionTiposDatosModalComponent, {
      data: { datos: "datos", dataTypeTree: this.dataTypeTree },
      minWidth: 600,
    });

    this.modalDataTypesSuscription = dialogRef
      .afterClosed()
      .subscribe((selectedDataTypes) => {
        let selectedData = selectedDataTypes as Array<any>;
        // console.log(selectedDataTypes)
        if (selectedData.length > 0) {
          this.selectedDataTypes = selectedDataTypes;
          sessionStorage.setItem(
            "selectedDataTypes",
            JSON.stringify(selectedDataTypes)
          );
        } else {
          sessionStorage.removeItem("selectedDataTypes");
        }
      });
  }

  openDatosModal(deviceId: string) {
    this.openDialogDatos(deviceId);
  }

  openDialogDatos(deviceId: string) {
    let selectedDataTypes: DataTypeItem[] = this.selectedDataTypes;
    // console.log(selectedDataTypes);
    if (sessionStorage.getItem("selectedDataTypes")) {
      selectedDataTypes = JSON.parse(
        sessionStorage.getItem("selectedDataTypes")
      );
    } else {
      selectedDataTypes = [];
    }

    // console.log('deviceId', deviceId);
    const dialogRef = this.dialog.open(DeviceDatosComponent, {
      data: {
        device: deviceId,
        selectedDataTypes: selectedDataTypes.map((dataType) => dataType.uuid),
      },
      minWidth: 600,
    });
    dialogRef.afterClosed(); //subscribe
  }
}
